const STORAGE_KEY = "twin_country";

function get(): string | null {
  return localStorage.getItem(STORAGE_KEY);
}

function set(countryCode: string) {
  localStorage.setItem(STORAGE_KEY, countryCode);
}

function clear() {
  localStorage.removeItem(STORAGE_KEY);
}

export const countryStorage = {
  get,
  set,
  clear,
};
